import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Messages} from "../../../../Messages";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {NewsletterSubscribePanelStyle} from "./NewsletterSubscribePanel";
import {BasePanelPage} from "../../../PanelPage";
import {startDashboardFlow} from "../../../flows/startFlow";


class NewsletterSubscribeSuccessPanelStyle extends NewsletterSubscribePanelStyle {
    @styleRule
    center = {
        textAlign: "center",
    };

    @styleRule
    title = this.themeProps.PANEL_TITLE;

    @styleRule
    link = this.themeProps.PANEL_LINK;
}

@registerStyle(NewsletterSubscribeSuccessPanelStyle)
export class NewsletterSubscribeSuccessPanel extends BasePanelPage {
    widthValue = 420;

    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.title}>{Messages.newsletterSubscribeSuccessTitle(iFrameMerchantService.getMerchant().getName())}</div>,
            <div className={styleSheet.message} style={{padding: "0 6px"}}>
                {Messages.newsletterSuccessMessage}<Link className={styleSheet.link} onClick={startDashboardFlow}>{Messages.myAccount}</Link>.
            </div>,
        ];
    }
}
